import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TenantContextService } from './tenant-context.service';
import { environment } from '../../environments/environment';

@Injectable()
export class TenantHeaderInterceptor implements HttpInterceptor {
  constructor(private tenantContext: TenantContextService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const tenantSlug = this.tenantContext.getTenantSlug();
    const isToApi = req.url.startsWith(environment.apiBaseUrl);

    if (!isToApi) return next.handle(req);

    // Detect explicit global prefix
    const relativeUrl = req.url.replace(environment.apiBaseUrl + '/', '');
    const isGlobalEndpoint = relativeUrl.startsWith('global/');

    if (isGlobalEndpoint) {
      const cleanedUrl = req.url.replace('/global/', '/'); // optional cleanup for backend
      const globalReq = req.clone({ url: cleanedUrl });
      this.debug(`🟢 [GLOBAL] ${req.method} → ${relativeUrl}`);
      return next.handle(globalReq);
    }

    // Tenant endpoints
    if (tenantSlug) {
      const tenantReq = req.clone({
        setHeaders: { 'x-tenant-slug': tenantSlug },
      });
      this.debug(`🏷️ [TENANT:${tenantSlug}] ${req.method} → ${relativeUrl}`);
      return next.handle(tenantReq);
    }

    this.debug(`⚠️ Missing tenant slug for ${req.method} ${relativeUrl}`);
    return next.handle(req);
  }

  private debug(message: string): void {
    if (!environment.production) console.log(`[TenantInterceptor] ${message}`);
  }
}

